import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
} from 'react-admin';

export const VerifiedExchangeList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
    </Datagrid>
  </List>
);

export const VerifiedExchangeEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="uid" label="UID" />
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const VerifiedExchangeCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="uid" label="UID" required />
      <TextInput source="name" required />
    </SimpleForm>
  </Create>
);

export const VerifiedExchangeShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="uid" label="UID" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);
